import React from 'react'
import FoldersPro from './FoldersPro';
import ItemsPro from './ItemsPro';
import PathCrumbs from './PathCrumbs';
import './FolderCard.css'

const FolderCard = () => {
  return (
    <div className='folderCard'>
      <div className='folderCardHeader'>
        <PathCrumbs />
      </div>
      <div className='folderCardBody'>
        <FoldersPro />
        <ItemsPro />
      </div>
    </div>
  )
}

export default React.memo(FolderCard);